import React from 'react'
import { PostList } from '../../components/post/PostList'

export const Posts = () => {
  return (
    <div className="posts-page">
      <section className="posts-hero">
        <div className="container">
          <p className="posts-hero__label">Blog</p>
          <h1 className="posts-hero__title">
            My <span className="text-color">Posts</span>
          </h1>
          <p className="posts-hero__text">
            Thoughts on frontend development, design, and building products that people enjoy using.
          </p>
        </div>
      </section>
      <section className="posts-content">
        <div className="container">
          <PostList />
        </div>
      </section>
    </div>
  )
}
